<template>
  <div class="warning_type_wrapper">
    <header>
      <h2>{{ $t("warning.title") }}</h2>
      <a-space>
        <!-- 已消除预警列表 -->
        <a-button @click="showDeletedWarningTypeModal">
          {{ $t("warning.deletedWarning") }}
        </a-button>
        <!-- 新增预警类型 -->
        <a-button type="primary" @click="showAddWarningTypeModal">
          {{ $t("warning.add") }}
        </a-button>
        <!-- 恢复 -->
        <a-button type="primary" @click="recoveryWarningTypeList">
          {{ $t("warning.recovery") }}
        </a-button>
        <!-- 编辑 -->
        <a-button type="primary" @click="toggleToEditOrSave">
          {{ isEdit ? $t("common.okText") : $t("buttons.edit") }}
        </a-button>
        <!-- 批量隐藏 -->
        <a-button
          v-show="selectedWarningTypesToDelete.length"
          type="danger"
          @click="showConfirmToSeparateWarningTypes"
        >
          {{ $t("warning.hide") }}
        </a-button>
      </a-space>
    </header>

    <CardDragger
      :data="selectedWarningTypes"
      :colNum="5"
      :cardOutsideWidth="340"
      :cardInsideWidth="300"
      :cardOutsideHeight="150"
      :cardInsideHeight="110"
      :draggable="isEdit"
      :count="count"
      :selectedWarningTypesToDelete="selectedWarningTypesToDelete"
      :toggleComponent="toggleComponent"
      @removeWarningType="showConfirmToHideWarningTypes"
    />

    <!-- 已消除预警列表对话框 -->
    <a-modal v-model="isDeletedWarningTypesModalVisible" :width="1500">
      <template #title>
        {{ $t("warning.deletedWarning") }}
        <a-button
          style="margin-left: 10px"
          type="primary"
          size="small"
          @click="openWarningDeletedLog()"
          >{{ $t("warning.history") }}</a-button
        >
      </template>
      <el-table
        height="600"
        v-loading="isDeletedWarningsTableLoading"
        :data="deletedWarningsList"
      >
        <el-table-column width="250">
          <template #header>
            <div
              style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;"
            >
              {{ $t("customer.company") }}
              <span
                class="icons unset"
                style="cursor: pointer;"
                @click="sortDeletedWarningTable($event, 'company')"
              >
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span>
            </div>
            <a-input
              v-model="deletedWarningsTableQueryParams.company"
              allow-clear
              @keyup.enter="renderDeletedWarningsTable(1)"
            />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="deletedWarningsTableHighlightInfo.company">
              {{ scope.row.company }}
            </text-highlight>
          </template>
        </el-table-column>
        <el-table-column width="130">
          <template #header>
            <div
              style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;"
            >
              {{ $t("common.deviceCode") }}
              <span
                class="icons unset"
                style="cursor: pointer;"
                @click="sortDeletedWarningTable($event, 'deviceCode')"
              >
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span>
            </div>
            <a-input
              v-model="deletedWarningsTableQueryParams.deviceCode"
              allow-clear
              @keyup.enter="renderDeletedWarningsTable(1)"
            />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="deletedWarningsTableHighlightInfo.deviceCode">
              {{ scope.row.deviceCode }}
            </text-highlight>
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div
              style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;"
            >
              {{ $t("common.deviceName") }}
              <span
                class="icons unset"
                style="cursor: pointer;"
                @click="sortDeletedWarningTable($event, 'deviceName')"
              >
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span>
            </div>
            <a-input
              v-model="deletedWarningsTableQueryParams.deviceName"
              allow-clear
              @keyup.enter="renderDeletedWarningsTable(1)"
            />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="deletedWarningsTableHighlightInfo.deviceName">
              {{ scope.row.deviceName }}
            </text-highlight>
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div
              style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;"
            >
              {{ $t("common.model") }}
              <span
                class="icons unset"
                style="cursor: pointer;"
                @click="sortDeletedWarningTable($event, 'model')"
              >
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span>
            </div>
            <a-input
              v-model="deletedWarningsTableQueryParams.model"
              allow-clear
              @keyup.enter="renderDeletedWarningsTable(1)"
            />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="deletedWarningsTableHighlightInfo.model">
              {{ scope.row.model }}
            </text-highlight>
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div
              style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;"
            >
              {{ $t("warning.warningTypes") }}
            </div>
            <a-select
              v-model.trim="deletedWarningsTableFilterParams.warningCode"
              style="width: 100%;"
              @change="renderDeletedWarningsTable(1)"
            >
              <a-select-option value="">{{ $t("common.all") }}</a-select-option>
              <a-select-option
                v-for="(v, k) in warningTypeCodeNameMap"
                :key="k"
                >{{ v[lang] }}</a-select-option
              >
            </a-select>
          </template>
          <template slot-scope="scope">
            {{ warningTypeCodeNameMap[scope.row.warningCode] ? warningTypeCodeNameMap[scope.row.warningCode][lang] : "" }}
          </template>
        </el-table-column>
         <el-table-column width="130">
          <template #header>
            <div
              style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;"
            >
              {{ $t("common.expiredAt") }}
               <span
                class="icons unset"
                style="cursor: pointer;"
                @click="sortDeletedWarningTable($event, 'expiredAt')"
              >
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span>
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.expiredAt }}
          </template>
        </el-table-column>
        <el-table-column width="100">
          <template #header>
            <div
              style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;"
            >
              {{ $t("common.createdAt") }}
              <span
                class="icons unset"
                style="cursor: pointer;"
                @click="sortDeletedWarningTable($event, 'createdAt')"
              >
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span>
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.createdAt }}
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div
              style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;"
            >
              {{ $t("common.createdBy") }}
              <span
                class="icons unset"
                style="cursor: pointer;"
                @click="sortDeletedWarningTable($event, 'createdBy')"
              >
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span>
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.createdBy }}
          </template>
        </el-table-column>
        <el-table-column width="100">
          <template #header>
            <div
              style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;"
            >
              {{ $t("common.updatedAt") }}
              <span
                class="icons DESC"
                style="cursor: pointer;"
                @click="sortDeletedWarningTable($event, 'updatedAt')"
              >
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span>
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.updatedAt }}
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div
              style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;"
            >
              {{ $t("common.updatedBy") }}
              <span
                class="icons unset"
                style="cursor: pointer;"
                @click="sortDeletedWarningTable($event, 'updatedBy')"
              >
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span>
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.updatedBy }}
          </template>
        </el-table-column>
        <el-table-column width="160">
          <template #header>
            <div
              style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;"
            >
              {{ $t("common.operation") }}
            </div>
          </template>
          <template slot-scope="scope">
            <a-button
              type="link"
              style="padding-left: 0;"
              @click="recoveryWarning(scope.row)"
              :loading="scope.row.loading"
              >{{ $t("warning.recovery") }}</a-button
            >
            <a-button
              type="link"
              style="padding-left: 5px;"
              @click="openWarningDeletedLog(scope.row)"
              >{{ $t("warning.history") }}</a-button
            >
          </template>
        </el-table-column>
      </el-table>
      <a-pagination
        style="float: right; margin-top: 10px; padding-bottom: 20px"
        :current="deletedWarningsTablePagination.current"
        :total="deletedWarningsTablePagination.total"
        @change="renderDeletedWarningsTable"
      />
      <div style="height: 30px;"></div>
    </a-modal>

    <!-- 消除预警操作日志对话框 -->
    <a-modal
      v-model="isLogModalVisible"
      :width="1000"
      :okButtonProps="{ style: { display : 'none' } }"
      :afterClose="clearLogsTableInfo"
    >
      <template #title>
        {{ $t("warning.history") }}
      </template>
      <el-table v-loading="isLogsTableLoading" height="600" :data="logs">
        <el-table-column>
          <template #header>
            <div
              style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;"
            >
              {{ $t("common.deviceCode") }}
            </div>
            <a-input
              v-model="logsTableQueryParams.deviceCode"
              allow-clear
              @keyup.enter="renderLogsTable"
            />
          </template>
          <template slot-scope="scope">
            {{ scope.row.deviceCode }}
          </template>
        </el-table-column>

        <el-table-column>
          <template #header>
            <div
              style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;"
            >
              {{ $t("warning.operator") }}
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.operator }}
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div
              style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;"
            >
              {{ $t("warning.warningTypes") }}
            </div>
          </template>
          <template slot-scope="scope">
            {{ warningTypeCodeNameMap[scope.row.warningCode][lang] }}
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div
              style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;"
            >
              {{ $t("common.operation") }}
            </div>
          </template>
          <template slot-scope="scope">
            {{ logTypes[scope.row.type][lang] }}
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div
              style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;"
            >
              {{ $t("common.expiredAt") }}
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.expiredAt }}
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div
              style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;"
            >
              {{ $t("common.changeTime") }}
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.time }}
          </template>
        </el-table-column>
      </el-table>
    </a-modal>

    <!-- 添加预警类型对话框 -->
    <a-modal
      v-model="isAddWarningTypeModalVisible"
      :title="$t('warning.hiddenTypes')"
      :width="700"
      :ok-text="$t('warning.show')"
      :confirm-loading="isAddWarningTypeModalConfirming"
      :afterClose="clearAddWarningTypeModalInfo"
      @ok="confirmToAddWarningType"
    >
      <a-form-model style="padding-left: 50px;" v-if="hiddenWarningTypes.length">
        <a-form-model-item :label="$t('warning.warningTypes')">
          <a-checkbox-group
            v-model="selectedWarningTypesInForm"
            style="width: 100%"
          >
            <a-row :gutter="24">
              <a-col
                v-for="h in hiddenWarningTypes"
                :span="lang === 'en' ? 12 : 8"
                :key="h.id"
              >
                <a-checkbox :value="h.id">
                  {{ lang === "en" ? h["en-US"] : h["zh-CN"] }}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
        </a-form-model-item>
      </a-form-model>
      <a-empty v-else :description="$t('warning.noHiddenWarningType')" />
    </a-modal>
  </div>
</template>

<script>
import CardDragger from "./CardDragger"
import TextHighlight from "vue-text-highlight"

import { getMenusOfCurrentUser } from "@/api/auth/menu"
import {
  getWarningList,
  pageIgnoreList,
  getIgnoreLog,
  restoreIgnoreWarning
} from "@/api/warning"


import moment from "moment"

export default {
  components: {
    CardDragger,
    TextHighlight
  },
  props: {
    toggleComponent: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      isEdit: false,
      selectedWarningTypesToDelete: [],
      selectedWarningTypes: [],
      hiddenWarningTypes: [],
      count: {},
      warningTypeCodeNameMap: {},
      /* 已消除预警对话框 */
      isDeletedWarningTypesModalVisible: false,
      isDeletedWarningsTableLoading: false,
      deletedWarningsList: [],
      deletedWarningsTableQueryParams: {
        company: "",
        deviceCode: "",
        deviceName: "",
        model: ""
      },
      deletedWarningsTableFilterParams: {
        warningCode: ""
      },
      deletedWarningsTableSortPatams: {
        updatedAt: "DESC"
      },
      deletedWarningsTableHighlightInfo: {
        company: "",
        deviceCode: "",
        deviceName: "",
        model: ""
      },
      deletedWarningsTablePagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      /* 消除预警操作日志对话框 */
      isLogModalVisible: false,
      isLogsTableLoading: false,
      logs: [],
      logsTableQueryParams: {
        deviceCode: ""
      },
      logTypes: {
        RESTORE: {
          zh: "恢复",
          en: "Restore"
        },
        INSERT: {
          zh: "消除",
          en: "Delete"
        }
      },
      /* 新增预警类型对话框 */
      isAddWarningTypeModalVisible: false,
      isAddWarningTypeModalConfirming: false,
      selectedWarningTypesInForm: []
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  mounted() {
    this.render()
  },
  methods: {
    /* 初始渲染 */
    async render() {
      await this.setWarningTypes_all()
      this.separateWarningTypes()
      this.setCount()
    },
    recoveryWarningTypeList() {
      localStorage.removeItem("selectedWarningTypes")
      this.render()
    },
    toggleToEditOrSave() {
      this.isEdit = !this.isEdit

      if (!this.isEdit) {
        const selectedWarningTypes = this.selectedWarningTypes
          .sort((a, b) => a.positionNum - b.positionNum)
          .map(s => s.id);
        localStorage.setItem(
          "selectedWarningTypes",
          JSON.stringify(selectedWarningTypes)
        )
      }
    },
    async setWarningTypes_all() {
      const warningTypes = await this.requestWarningMenus()
      
      const i = warningTypes.findIndex(w => w.routeName === "WarningOrder")
      if (i > -1) {
        warningTypes.splice(i, 1)
      }

      let selectedWarningTypes = JSON.parse(localStorage.getItem('selectedWarningTypes')), length = warningTypes.length, index
      if (!selectedWarningTypes) {
        selectedWarningTypes = warningTypes.map(m => m.id)
      }

      this.warningTypes_all = warningTypes
        .map(w => {
          (w.details || []).forEach(d => {
            w[d.locale] = d.name
          })
          w.name = w["zh-CN"]
          this.warningTypeCodeNameMap[w.routeName] = {
            zh: w["zh-CN"],
            en: w["en-US"]
          }

          index = selectedWarningTypes.findIndex(s => s === w.id)
          if (index > -1) {
            w.positionNum = index + 1
            w.hide = false
          } else {
            w.hide = true
            w.positionNum = length + 1
          }

          return w
        })
        .sort((a, b) => a.positionNum - b.positionNum)
    },
    separateWarningTypes(flag = true) {
      const selectedWarningTypes = []
      const hiddenWarningTypes = []
      let t, p = 0
      for (let i = 0; i < this.warningTypes_all.length; i++) {
        t = this.warningTypes_all[i]
        const di = this.selectedWarningTypesToDelete.findIndex(w => w === t.id)
        if (t.hide && di < 0) {
          hiddenWarningTypes.push(t)
        } else {
          t.positionNum = ++p
          selectedWarningTypes.push(t)
        }
      }
      this.selectedWarningTypes = selectedWarningTypes
      this.hiddenWarningTypes = hiddenWarningTypes
      flag && (this.selectedWarningTypesToDelete = [])
    },
    async setCount() {
      const count = {}, promises = []

      for (let i = 0; i < this.selectedWarningTypes.length; i++) {
        if (this.selectedWarningTypes[i].routeName !== "DeviceAllWarnings") {
          promises.push(
            new Promise(async resolve => {
              const s = this.selectedWarningTypes[i]
              const n = await this.requestWarnings(s.routeName)
              count[s.id] = n
              resolve()
            })
          )
        }
      }

      await Promise.all(promises)
      this.count = count
    },
    /* 已消除预警列表对话框 */
    showDeletedWarningTypeModal() {
      this.isDeletedWarningTypesModalVisible = true
      this.renderDeletedWarningsTable()
    },
    async renderDeletedWarningsTable(p = this.deletedWarningsTablePagination.current) {
      this.deletedWarningsTablePagination.current = p
      this.isDeletedWarningsTableLoading = true

      const { records, total } = await this.requestDeletedWarnings()
      this.deletedWarningsTablePagination.total = total
      this.deletedWarningsList = records.map(r => {
        if (r.createdAt) {
          r.createdAt = moment(r.createdAt).format("YYYY-MM-DD HH:mm:ss")
        }

        if (r.updatedAt) {
          r.updatedAt = moment(r.updatedAt).format("YYYY-MM-DD HH:mm:ss")
        }

        if (r.expiredAt) {
          r.expiredAt = moment(r.expiredAt).format("YYYY-MM-DD HH:mm:ss")
        }
        
        return r
      })

      for (let key in this.deletedWarningsTableHighlightInfo) {
        this.deletedWarningsTableHighlightInfo[key] = this.deletedWarningsTableQueryParams[key] || ""
      }

      this.isDeletedWarningsTableLoading = false
    },
    sortDeletedWarningTable(e, field) {
      let node = e.target
      while (node.nodeName !== "SPAN") {
        node = node.parentNode
      }

      let originClass = node.classList[1], c
      node.classList.remove(originClass)

      switch (originClass) {
        case "unset":
          c = "ASC"
          break
        case "ASC":
          c = "DESC"
          break
        case "DESC":
          c = "unset"
          break
        default:
          break
      }

      node.classList.add(c)
      this.deletedWarningsTableSortPatams[field] = c
      this.renderDeletedWarningsTable()
    },
    recoveryWarning(r) {
      this.$confirm({
        title: this.$t("warning.confirmRecovery"),
        content: this.$t("warning.confirmText"),
        onOk: async () => {
          const { success, message } = await this.requestRecoveryWarning(r.warningCode, r.deviceId)
          if (success) {
            this.$message.success(message)
            this.renderDeletedWarningsTable()
          }
        }
      })
    },
    setDeletedWarningsTableSearchParams() {
      const params = {
        query: [],
        filter: [],
        sort: []
      }

      let value
      for (let key in this.deletedWarningsTableQueryParams) {
        value = this.deletedWarningsTableQueryParams[key].trim()

        if (value) {
          params.query.push({
            field: key,
            value
          })
        }
      }

      for (let key in this.deletedWarningsTableFilterParams) {
        value = this.deletedWarningsTableFilterParams[key]
        if (value) {
          params.filter.push({
            field: key,
            value: this.deletedWarningsTableFilterParams[key]
          })
        }
      }

      if (params.filter.length) {
        params.filter.push({
          field: "mode",
          value: "AND"
        })
      }

      for (let key in this.deletedWarningsTableSortPatams) {
        value = this.deletedWarningsTableSortPatams[key]

        if (value !== "unset") {
          params.sort.push({
            field: key,
            value: this.deletedWarningsTableSortPatams[key]
          })
        }
      }

      return params
    },
    /* 消除预警操作日志对话框 */
    async openWarningDeletedLog(r) {
      this.isLogModalVisible = true

      if (r) {
        this.logsTableQueryParams.deviceCode = r.deviceCode
        this.renderLogsTable()
      }
    },
    async renderLogsTable() {
      let value = this.logsTableQueryParams.deviceCode.trim()

      if (value) {
        this.isLogsTableLoading = true
        const logs = await this.requestIgnoreLogs()
        this.logs = logs.map(l => {
          if (l.expiredAt) {
            l.expiredAt = moment(l.expiredAt).format("YYYY-MM-DD HH:mm:ss")
          }

          if (l.time) {
            l.time = moment(l.time).format("YYYY-MM-DD HH:mm:ss")
          }

          return l
        })

        this.isLogsTableLoading = false
      } else {
        this.logs = []
      }
    },
    clearLogsTableInfo() {
      this.logsTableQueryParams.deviceCode = ""
      this.logs = []
    },
    /* 添加预警类型对话框 */
    showAddWarningTypeModal() {
      this.isAddWarningTypeModalVisible = true
    },
    clearAddWarningTypeModalInfo() {
      this.selectedWarningTypesInForm = []
    },
    confirmToAddWarningType() {
      this.isAddWarningTypeModalConfirming = true

      let t
      for (let i = 0; i < this.selectedWarningTypesInForm.length; i++) {
        t = this.warningTypes_all.find(w => w.id === this.selectedWarningTypesInForm[i])
        if (t) {
          t.hide = false
        }
      }
      this.separateWarningTypes(false)

      this.isAddWarningTypeModalConfirming = false
      this.isAddWarningTypeModalVisible = false

      const selectedWarningTypes = this.selectedWarningTypes
        .sort((a, b) => a.positionNum - b.positionNum)
        .map(s => s.id)
      localStorage.setItem(
        "selectedWarningTypes",
        JSON.stringify(selectedWarningTypes)
      )

      this.setCount()
    },
    /* 隐藏预警确认框 */
    showConfirmToHideWarningTypes(id) {
      this.$confirm({
        title: this.$t("warning.confirmHide"),
        content: this.$t("warning.confirmHideContent"),
        onOk: () => {
          const type = this.warningTypes_all.find(w => w.id === id)
          if (type) {
            type.hide = true
          }

          this.separateWarningTypes()
        }
      })
    },
    /* 批量隐藏预警类型确认框 */
    showConfirmToSeparateWarningTypes() {
      this.$confirm({
        title: this.$t("warning.confirmHide"),
        content: this.$t("warning.confirmHideContent"),
        onOk: () => {
          this.selectedWarningTypesToDelete = []
          this.separateWarningTypes()
        }
      })
    },
    /* 请求 */
    async requestWarningMenus() {
      try {
        const { data } = await getMenusOfCurrentUser()
        const menu = data.find(r => r.id === 40)

        return menu.children ?? []
      } catch (e) {
        console.log(e)
        return []
      }
    },
    async requestWarnings(type) {
      const params = {
        query: [],
        filter: [],
        sort: []
      }

      if (type === "MAINTAIN") {
        params.filter = [
          {
            field: "leaveDays",
            value: 30
          }
        ]
      }

      try {
        const { data } = await getWarningList(
          {
            current: 1,
            pageSize: 1,
            latest: true,
            type
          },
          params
        )

        return data.total
      } catch(e) {
        console.log(e)
        return 0
      }
    },
    async requestDeletedWarnings() {
      try {
        const { data } = await pageIgnoreList(
          this.deletedWarningsTablePagination.current,
          this.deletedWarningsTablePagination.pageSize,
          this.setDeletedWarningsTableSearchParams()
        )
        return data
      } catch(e) {
        console.log(e)
        return {
          records: [],
          total: 0
        }
      }
    },
    async requestIgnoreLogs() {
      try {
        const { data } = await getIgnoreLog(
          this.logsTableQueryParams.deviceCode,
          +new Date("2020-01-01"),
          +new Date("2099-12-31")
        )
        return data
      } catch(e) {
        console.log(e)
        return []
      }
    },
    async requestRecoveryWarning(warningCode, deviceId) {
      try {
        const { message } = await restoreIgnoreWarning(warningCode, deviceId)
        return {
          success: true,
          message
        }
      } catch(e) {
        console.log(e)
        return {
          success: false,
          message: ""
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
h2 {
  margin: 0;
  padding: 0;
}

.warning_type_wrapper {
  width: 100%;
  padding: 20px;
  padding-bottom: 0;

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

span.icons {
  position: relative;
}

.anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -8px;
  font-size: 14px;
  color: #ccc;
}

span.ASC .anticon-caret-up {
  color: #1890ff;
}

span.icons {
  position: absolute;
  right: 18px;
}

span.DESC .anticon-caret-down {
  color: #1890ff;
}

.anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -8px;
  font-size: 14px;
  color: #ccc;
}

/deep/ .ant-select-selection__rendered {
  font-weight: normal;
}
</style>